import axios from 'util/Api'
import { useQuery } from '@tanstack/react-query';

const GetUserCalendarEvents = async (props) => {

	const Afid = props.queryKey[1] !== undefined ? props.queryKey[1] : 0;
	const Userid = props.queryKey[2] !== undefined ? props.queryKey[2] : 0;
	const Users = props.queryKey[3] !== undefined ? props.queryKey[3] : [];
	const FromDate = props.queryKey[4] !== undefined ? props.queryKey[4] : new Date();
	const ToDate = props.queryKey[5] !== undefined ? props.queryKey[5] : new Date();

	let url = `/projekt/getUserCalendarEvents`;

  const jwt =  JSON.parse(localStorage.token);

	const results = await axios
		.get(url, {
      params: {Afid, Userid, Users, FromDate, ToDate},
      headers: { 'Authorization':`Bearer ${jwt}`}})
		.then((response) => response.data);
	return results;
};


export const useGetUserCalendarEvents = (Afid, Userid, Users, FromDate, ToDate) => {

	const query = useQuery({
		queryKey: ['getUserCalendarEvents', Afid, Userid, Users, FromDate, ToDate],
		// queryFn: GetUserCalendarEvents,
		refetchOnWindowFocus: false,
		// enabled: Orders.length > 0,
		
		failureCount: 3,
		queryFn: GetUserCalendarEvents,
		retry: (failureCount, error) => {
			return false
			// Retry only if the failure count is less than or equal to 3 and the error is due to a 500 status code
			return (
				error.response?.status !== 401 &&
				error.response?.status !== 404 &&
				error.response?.status !== 403
			);
		},
	});
	return query;
};
